import { useState, useEffect } from 'react';
import noop from 'utils/noop';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { InputText } from 'ui/inputs';
import { MenuItemContentWrapper, InputMenuItemWrapper, ButtonGroup } from './Styled';

export type InputMenuProps = {
  /** unique identified for the component */
  id: string;
  /** Callback function to call when there is a string query change */
  onStringQueryChange?: (query?: string) => void;
  /** Text that will be displayed in the primary button of an input menu item */
  primaryButtonText?: string;
  /** Text that will be displayed in the secondary button of an input menu item */
  secondaryButtonText?: string;
  /** the default text for the input box */
  stringQuery?: string;
};

export const InputMenuItem = ({
  id,
  onStringQueryChange = noop,
  primaryButtonText = 'Apply',
  secondaryButtonText = 'Cancel',
  stringQuery = '',
}: InputMenuProps) => {
  const [input, setInput] = useState(stringQuery);

  useEffect(() => {
    setInput(stringQuery);
  }, [stringQuery]);

  const handleSubmit = () => {
    onStringQueryChange(input);
  };

  const handleCancel = () => {
    onStringQueryChange();
  };

  return (
    <MenuItemContentWrapper as="li" data-test={`input-menu-item-${id}`}>
      <InputMenuItemWrapper>
        <InputText onChange={setInput} value={input} />
        <ButtonGroup>
          <SecondaryButton onClick={handleCancel}>{secondaryButtonText}</SecondaryButton>
          <PrimaryButton onClick={handleSubmit}>{primaryButtonText}</PrimaryButton>
        </ButtonGroup>
      </InputMenuItemWrapper>
    </MenuItemContentWrapper>
  );
};
